<div class="wrapper page-heading page-heading-header-bg">
    <div class="row">
        <div class="col-xs-6 title-left">
            <h1 [i18n]="'df-management.df-logs.title'"></h1>
        </div>
        <div class="col-md-3 dropdownAlignment">
            <div class="data-filter" [formGroup]="searchForm">
                <ng-select placeholder={{selectCountry}} formControlName="country"
                (change)="updateCountry($event)">
                        <ng-option *ngFor="let column of countryData" [value]="column">
                            {{column.country}}
                        </ng-option>
                    </ng-select>
            </div>
        </div>
        <div>
            <img class="bellIconAlerts" src="assets/NotificationWhite.svg"
                         alt="bellIcon" (click)="openPopup()">
            <app-notification-alert *ngIf="isPopupVisible | async" [countryCode]="countryCode" [customOverlayClass]="'custom-popup-overlay'" ></app-notification-alert>
        </div>
    </div>
</div>

<section class="chepfm--section__filters">
    <div class="container">
        <form class="chepfm--filter__form" [formGroup]="searchForm" >
            <div class="row">
                <div class="col-md-4 col-sm-4">
                    <div class="data-filter">
                        <label [i18n]="'df-management.df-logs.searchList.selectJob'"></label>
                        <ng-select formControlName="selectedJobs" [multiple]="true" placeholder={{selectJobs}} [hideSelected]="true" [clearable]="false" [searchable]="true" (change)="onSelectionChange($event)">
                            <ng-option *ngFor="let job of jobs" [value]="job" [disabled]="isOptionDisabled(job)">
                                {{ job.name }}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>

                <div class="col-md-4 col-sm-4">
                    <label [i18n]="'df-management.df-logs.searchList.logStartDate'"></label>
                    <div class="input-icons">
                        <input class="form-control calender-icon" [dpDayPicker]="dateConfig" [theme]="'date-time-picker'"
                            placeholder={{selectDate}} formControlName="startDate">
                    </div>
                </div>
                
                <div class="col-md-4 col-sm-4">
                    <label [i18n]="'df-management.df-logs.searchList.logEndDate'"></label>
                    <div class="input-icons">
                        <input class="form-control calender-icon" [dpDayPicker]="dayConfig" [theme]="'date-time-picker'"
                            placeholder={{selectDate}} formControlName="endDate">
                    </div>
                </div>
                
            </div>
            <div class="row search-filter">
                <div class="col-md-4 col-sm-4">
                    <div class="data-filter">
                        <label [i18n]="'df-management.df-logs.searchList.selectStatus'"></label>
                        <ng-select formControlName="status" placeholder={{selectStatus}}  [clearable]="false" [searchable]="true">
                            <ng-option value="Succeed" [i18n]="'df-management.df-logs.options.succeed'"></ng-option>
                            <ng-option value="Partially Succeed"  [i18n]="'df-management.df-logs.options.partiallySucceed'"></ng-option>
                            <ng-option value="In Progress"  [i18n]="'df-management.df-logs.options.inProgress'"></ng-option>
                            <ng-option value="Failed"  [i18n]="'df-management.df-logs.options.failed'"></ng-option>
                        </ng-select>
                    </div>                    
                </div>
        </div>
            <div class="row">   
                <div class="col-md-auto col-sm-2 pull-right">
                    <div class="chepfm--filter__actions">
                        <span><i class="fa fa-ban repeat--icon" aria-hidden="true"></i></span>&nbsp;
                        <a class="chepfm--link" (click)="resetSearchData()">
                            <span [i18n]="'df-management.df-transaction.filters.buttons.reset-button'"></span>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        <button class="btn btn-i btn-primary" type="submit" [disabled]="searchForm.invalid || !searchForm.get('country').value" (click)="applySearch()">
                            <span [i18n]="'df-management.df-transaction.filters.buttons.apply-button'"></span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</section>

<section class="chepfm--sections__card-wrapper" *ngIf="isVisibleCards">
    <div class="container">
        <div class="card-parent" >
            <div class="child-card" (click)="filterAssetsOrCarriers()">
                <div class="card chepfm--sections__card">
                    <div class="card-body" >
                        <div class="chepfm--sections__card-info">
                            <div class="chepfm--sections__card-title" [i18n]="countryCode === 'USA' ? 'df-management.df-logs.searchList.carrierSearch' : 'df-management.df-logs.searchList.assetSearch'"></div>
                            <div class="chepfm--sections__card-count">{{ countryCode === 'USA' ? pageTransData?.carrier_search_count : pageTransData?.asset_search_count }}</div>
                        </div>
                        <img src="assets/trans-load.svg"
                            class="img-fluid tile-icon" alt="noLoadIcon">
                    </div>
                </div>
            </div>
            <div class="child-card" (click)="filterNoOfLoads()">
                <div class="card chepfm--sections__card">
                    <div class="card-body" >
                        <div class="chepfm--sections__card-info">
                            <div class="chepfm--sections__card-title" [i18n]="'df-management.df-transaction.form.card-heading.load-search'"></div>
                            <div class="chepfm--sections__card-count">{{pageTransData?.load_search_count}}</div>
                            </div>
                            <img src="assets/trans-created.svg"
                            class="img-fluid tile-icons" alt="noLoadIcon">
                    </div>
                </div>
            </div>
            <div class="child-card" *ngIf="countryCode !== 'USA'" (click)="filterAutomaticCharges()">
                <div class="card chepfm--sections__card">
                    <div class="card-body" >
                        <div class="chepfm--sections__card-info">
                            <div class="chepfm--sections__card-title" [i18n]="'df-management.df-transaction.form.card-heading.auto-calculation'"></div>
                            <div class="chepfm--sections__card-count">{{pageTransData?.auto_calculation_job_count}}</div>
                        </div>
                        <img src="assets/autoCalculationIcon.svg"
                            class="img-fluid tiles-icon" alt="userCountIcon">
                    </div>
                </div>
            </div>
            <div class="child-card" (click)="filterNoOfVouchers()">
                <div class="card chepfm--sections__card">
                    <div class="card-body" >
                        <div class="chepfm--sections__card-info">
                            <div class="chepfm--sections__card-title" [i18n]="'df-management.df-transaction.form.card-heading.voucher-update'"></div>
                            <div class="chepfm--sections__card-count">{{pageTransData?.voucher_update_job_count}}</div>
                            </div>
                            <img src="assets/trans-success.svg"
                                class="img-fluid tiles-icon" alt="userCountIcon">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container summary-panel">

    <app-data-table [columns]="columns" [sortColumn]="sortColumn" [loadPage]="loadPage" [(filters)]="filters"
                    
                    [showColumnsSelection]="false" >
    </app-data-table>

<ng-template #jobNameColumn let-jobName="jobName">
    <span >{{ jobName }}</span>
</ng-template>
<ng-template #jobTypeColumn let-jobType="jobType">
    <span >{{ jobType }}</span>
</ng-template>
<ng-template #jobStatusColumn let-jobStatus="jobStatus">
    <span >{{ jobStatus }}</span>
</ng-template>
<ng-template #logDateColumn let-createdDate="createdDate">
    <span >{{ createdDate | dfFullDate }}</span>
</ng-template>
<ng-template #durationColumn let-duration="duration">
    <span >{{ duration  }}</span>
</ng-template>
<ng-template #recordProcessedColumn let-recordsProcessed="recordsProcessed">
    <span >{{ recordsProcessed }}</span>
</ng-template>
<ng-template #responseInsightColumn let-item="item">
   <div>
    <img src="assets/exporticon.svg" (click)="openContextualData(item)"
    class="img-fluid expcpy" alt="exportIcon">&nbsp;&nbsp;
    <img src="assets/Vector.svg" (click)="copyJson(item.notEligibleRecords)"
    class="img-fluid expcpy" alt="copyjsonIcon">
   </div>
</ng-template>
</section>

 
